import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import HsCodeAdditionalService from "../../Services/HsCodeAdditionalService";

export const AddHsCodeAdditionalFees = ({
  setAddmodalshow,
  getData,
  countryList,
  setCountryList,
}) => {
  const [loader, setLoader] = useState(false);

  const initialValues = {
    country_id: "",
    hs_code: "",
    additional_charge: "",
  };

  const validationSchema = Yup.object().shape({
    hs_code: Yup.string().required("Required"),
    additional_charge: Yup.string().required("Required"),
    country_id: Yup.string().required("Required"),
  });

  const onSubmit = (fields) => {
    console.log(fields, "fields");
    setLoader(true);
    HsCodeAdditionalService.addHscodeadditionalfees(fields).then((res) => {
      if (res.status) {
        toast.success(res.msg);
        setLoader(false);
        setAddmodalshow(false);
        getData();
      } else {
        setLoader(false);
        toast.error(res.msg);
      }
    });
  };

  const onCountryChange = (e, name, setFieldValue) => {
    setFieldValue([name], e.value);
  };

  return (
    <div className="row d-flex justify-content-center">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          errors,
          values,
          touched,
          setValues,
          setFieldValue,
          getFieldProps,
          setFieldError,
        }) => (
          <Form className="control-form" autoComplete="off">
            {/* country  */}

            <div className="mb-3 row">
              <div className="col-12">
                <label className="form-label">Country </label>
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      borderColor: touched.country_id
                        ? !errors.country_id
                          ? "#34c38f"
                          : "#f46a6a"
                        : "#ced4da",
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  onChange={(e) =>
                    onCountryChange(e, "country_id", setFieldValue)
                  }
                  options={countryList}
                />
                {touched.country_id && errors.country_id ? (
                  <div className="text-danger">{errors.country_id}</div>
                ) : null}
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col-12">
                <label className="form-label">HS Code</label>
                <Field
                  type="number"
                  className={
                    "form-control" +
                    (touched.hs_code && errors.hs_code ? " is-invalid" : "")
                  }
                  name="hs_code"
                  placeholder="Enter HS Code"
                />
                {touched.hs_code && errors.hs_code ? (
                  <div className="text-danger">{errors.hs_code}</div>
                ) : null}
              </div>

              <div className="mb-3 col-12">
                <label className="form-label">Additional Charge</label>
                <Field
                  type="number"
                  className={
                    "form-control" +
                    (touched.additional_charge && errors.additional_charge
                      ? " is-invalid"
                      : "")
                  }
                  name="additional_charge"
                  placeholder="Enter Additional Charge"
                />
                {touched.additional_charge && errors.additional_charge ? (
                  <div className="text-danger">{errors.additional_charge}</div>
                ) : null}
              </div>
            </div>

            <div className="mt-3 mb-3 d-flex justify-content-between">
              <button
                className="btn btn-danger w-sm waves-effect waves-light"
                type="button"
                onClick={() => setAddmodalshow(false)}
              >
                Back
              </button>
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                type="submit"
              >
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <Loader isShow={loader} />
    </div>
  );
};
